/**
 * CFI (Complete First Item) Section JavaScript
 * Handles add to cart functionality for CFI bundles
 */

class CFISection {
  constructor() {
    this.form = document.getElementById('cfi-form');
    this.addButton = this.form?.querySelector('.product-form__add-button');
    
    if (this.form) {
      this.init();
    }
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    if (this.form) {
      this.form.addEventListener('submit', this.handleSubmit.bind(this));
    }
  }

  async handleSubmit(event) {
    event.preventDefault();
    
    if (!this.addButton) return;

    // Disable button and show loading state
    this.addButton.disabled = true;
    this.addButton.classList.add('button--loading');
    
    const originalText = this.addButton.textContent;
    this.addButton.textContent = 'Se adaugă...';

    try {
      // Get form data
      const formData = new FormData(this.form);
      
      // Convert to cart items format
      const items = this.getCartItems(formData);
      
      // Add to cart
      const response = await this.addToCart(items);
      
      if (response.ok) {
        // Show success message
        this.showSuccessMessage();
        
        // Update cart count
        this.updateCartCount();
        
        // Dispatch cart refresh event
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: { scrollToTop: false }
        }));
      } else {
        throw new Error('Failed to add to cart');
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
      this.showErrorMessage();
    } finally {
      // Reset button state
      this.addButton.disabled = false;
      this.addButton.classList.remove('button--loading');
      this.addButton.textContent = originalText;
    }
  }


  getCartItems(formData) {
    const items = [];
    const itemCount = this.getFormItemCount(formData);
    
    for (let i = 0; i < itemCount; i++) {
      const id = formData.get(`items[${i}][id]`);
      const quantity = parseInt(formData.get(`items[${i}][quantity]`)) || 1;
      
      if (id) {
        items.push({
          id: id,
          quantity: quantity
        });
      }
    }
    
    return items;
  }

  getFormItemCount(formData) {
    let maxIndex = -1;
    for (const key of formData.keys()) {
      const match = key.match(/items\[(\d+)\]/);
      if (match) {
        const index = parseInt(match[1]);
        if (index > maxIndex) {
          maxIndex = index;
        }
      }
    }
    return maxIndex + 1;
  }

  async addToCart(items) {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: items })
    });
    
    return response;
  }

  showSuccessMessage() {
    // Create success notification
    const notification = document.createElement('div');
    notification.className = 'cfi-notification cfi-notification--success';
    notification.innerHTML = `
      <div class="cfi-notification__content">
        <span class="cfi-notification__icon">✓</span>
        <span class="cfi-notification__text">Produsele au fost adăugate în coș!</span>
      </div>
    `;
    
    document.body.appendChild(notification);
    
    // Show notification
    setTimeout(() => {
      notification.classList.add('cfi-notification--visible');
    }, 100);
    
    // Remove notification after 3 seconds
    setTimeout(() => {
      notification.classList.remove('cfi-notification--visible');
      setTimeout(() => {
        document.body.removeChild(notification);
      }, 300);
    }, 3000);
  }

  showErrorMessage() {
    // Create error notification
    const notification = document.createElement('div');
    notification.className = 'cfi-notification cfi-notification--error';
    notification.innerHTML = `
      <div class="cfi-notification__content">
        <span class="cfi-notification__icon">✗</span>
        <span class="cfi-notification__text">Eroare la adăugarea în coș. Vă rugăm să încercați din nou.</span>
      </div>
    `;
    
    document.body.appendChild(notification);
    
    // Show notification
    setTimeout(() => {
      notification.classList.add('cfi-notification--visible');
    }, 100);
    
    // Remove notification after 5 seconds
    setTimeout(() => {
      notification.classList.remove('cfi-notification--visible');
      setTimeout(() => {
        document.body.removeChild(notification);
      }, 300);
    }, 5000);
  }

  updateCartCount() {
    // This will be handled by the cart refresh event
    // The cart count will be updated automatically
  }
}

// Initialize CFI section when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new CFISection();
});

// Also initialize if DOM is already loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new CFISection();
  });
} else {
  new CFISection();
}
